import * as React from "react";

import type {SandboxContext as SandboxContextType} from "../internal/sandbox-context.ts";

import {useSandboxContext} from "./use-sandbox-context.ts";

export type WithSandboxContextProps = SandboxContextType;

export type WithoutSandboxContext<T> = Partial<
    Omit<T, keyof WithSandboxContextProps>
>;

/**
 * This HOC wraps a component with the React Sandbox context and the
 * Apollo Client scoped to the React tree at this point.
 */
export default function withSandboxContext<
    Config extends WithSandboxContextProps,
    Component extends React.ComponentType<Config>,
>(
    WrappedComponent: Component,
): React.ComponentType<
    WithoutSandboxContext<
        JSX.LibraryManagedAttributes<Component, React.ComponentProps<Component>>
    >
> {
    return (props: unknown) => {
        const sandboxContext = useSandboxContext();
        // @ts-expect-error - TS2322 - Type '{ log: (message: string, ...args: any[]) => void; isInFixture: boolean; uniqueId: string; }' is not assignable to type 'LibraryManagedAttributes<Component, Config>'.
        return <WrappedComponent {...props} {...sandboxContext} />;
    };
}
